import { FC } from "react";
import BarLoader from "react-spinners/BarLoader";
import Fade from "react-spinners/FadeLoader";

interface LoaderProps {}

const Loader: FC<LoaderProps> = () => {
  return (
    <div className="flex-1 flex flex-col space-y-6 items-center justify-center">
      <span className="text-gray-600 text-sm">Loading details...</span>
      <BarLoader
        color={"#017CB8"}
        loading={true}
        cssOverride={{ width: "30%" }}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export default Loader;

const FadeLoader: FC<LoaderProps> = () => {
  return (
    <div className="flex-1 flex flex-col space-y-6 items-center justify-center">
      <Fade
        color={"#017CB8"}
        loading={true}
        cssOverride={{ width: "30%" }}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export { FadeLoader };
